module.exports = __webpack_public_path__ + "static/media/iv_profile_support.f2827e13.svg";